import styled from "styled-components";

export const MapPositionWrapper = styled.div`
    width: 100%;
    height: 100%;
    color: #FFFFFF;
    .amap-info-content {
        background-color: rgba(0, 0, 0, 0.5);
        padding-right: 10px;
        z-index: 200;
    }

    .amap-info-sharp {
        border-top: 8px solid rgba(0, 0, 0, 0.2);
    }
`;

